/** Proactivity pause ("snooze") helpers shared by Pulse and Réglages. */
import type { AgentSettings } from "../../shared/contracts";
import { isValidHm, isValidTimezone, nextLocal } from "../../shared/time";
import { api } from "./api";
import { mutateResource, invalidate } from "./store";

const HOUR = 3_600_000;

export function isSnoozed(settings: Pick<AgentSettings, "snoozeUntil">, now: number = Date.now()): boolean {
  return typeof settings.snoozeUntil === "number" && settings.snoozeUntil > now;
}

/** Next local start of the active hours in the user's own time zone ("demain matin"). */
export function nextMorning(settings: Pick<AgentSettings, "timezone" | "activeStart">, now: number = Date.now()): number {
  const tz = isValidTimezone(settings.timezone) ? settings.timezone : "Europe/Paris";
  const hm = isValidHm(settings.activeStart) ? settings.activeStart : "08:00";
  return nextLocal(tz, hm, now);
}

export function oneHourFrom(now: number = Date.now()): number {
  return now + HOUR;
}

/** "jeudi 30 octobre à 08:00", in the browser's locale/time zone. */
export function fmtSnoozeUntil(ms: number): string {
  return new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" }).format(ms);
}

/** PATCH /api/settings {snoozeUntil} and refresh every cached view of the settings. */
export async function setSnooze(until: number | null): Promise<AgentSettings> {
  const settings = await api("PATCH /api/settings", { body: { snoozeUntil: until } });
  mutateResource<AgentSettings>("settings", () => settings);
  invalidate("dashboard");
  return settings;
}
